var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pool',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"title":"岗位情况","dataList":_vm.showDataList,"countList":_vm.countList},on:{"chooseCount":_vm.chooseCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }